import { Component, inject, OnDestroy, OnInit } from '@angular/core';

import { GlobalHeroComponent } from '../../shared/components/global-hero/global-hero.component';
import { JumpToComponent } from '../../shared/components/jump-to/jump-to.component';
import { WhatIsScreenComponent } from './what-is-screen/what-is-screen.component';
import { GetScreenedComponent } from './get-screened/get-screened.component';
import { HowCanScreenComponent } from './how-can-screen/how-can-screen.component';
import { AutoantibodiesComponent } from './autoantibodies/autoantibodies.component';
import { CtaBottomComponent } from '../../shared/components/cta-bottom/cta-bottom.component';
import { CommonModule } from '@angular/common';
import { ScrollSpyService } from '../../shared/services/scroll-spy.service';
import { Observable } from 'rxjs';
import { VideoSection } from './video-section/video-section';
import { appPaths } from '../../app.paths';
import { FindASpecialistComponent } from './find-a-specialist/find-a-specialist.component';
import { ReviewBarComponent } from '../../shared/components/review-bar/review-bar.component';

@Component({
  selector: '[how-to-screen]',
  imports: [
    CommonModule,
    GlobalHeroComponent,
    JumpToComponent,
    WhatIsScreenComponent,
    // GetScreenedComponent,
    HowCanScreenComponent,
    AutoantibodiesComponent,
    CtaBottomComponent,
    VideoSection,
    FindASpecialistComponent,
    ReviewBarComponent,
  ],
  templateUrl: './how-to-screen.component.html',
  styleUrl: './how-to-screen.component.scss',
})
export class HowToScreenComponent implements OnInit, OnDestroy {
  scrollSpyService = inject(ScrollSpyService);

  activeSection$!: Observable<string | null>;

  heroData = {
    backgroundImageDesktop: 'hero-how-to-screen',
    titleText: 'HOW TO SCREEN FOR',
    bodyTextDesktopWidth: '',
    titleColorText: '<br /> <span class="fst-normal"> TYPE 1</span> DIABETES',
    bodyText: 'Learn more about what screening is, where you can access it, and how you can find a doctor.',
    sillHouetteImage: 'hero-sillhouette-how-to-screen',
    sillhouette: {
      mobile: {
        width: 287,
        top: 0,
        left: 50,
      },
      tablet: {
        width: 304,
        top: 0,
        left: 56,
      },
      desktop: {
        width: 579,
        height: 331,
        top: 2,
        left: 106,
      },
    },
    sillhouetteAlt:
      'A mother and daughter talking to their doctor',
  };

  jumpToData = [
    {
      buttonLabel: 'What is type 1 screening?',
      buttonUrl: '/',
      buttonFragment: 'what-is-screening',
    },
    {
      buttonLabel: 'How can you screen?',
      buttonUrl: '/',
      buttonFragment: 'how-to-screen',
    },
    {
      buttonLabel: 'What do the results mean?',
      buttonUrl: '/',
      buttonFragment: 'screening-results',
    },
    {
      buttonLabel: 'Find a doctor',
      buttonUrl: '/',
      buttonFragment: 'find-a-specialist',
    },
  ];

  ctaBottomData = {
    icon: 'clipboard',
    alt: 'A clipboard and a vial',
    title: 'Speak to your doctor about your screening options',
    button: {
      buttonLabel: 'Doctor Discussion Guide',
      buttonUrl:
        '/assets/pdf/type-1-diabetes-screening-doctor-discussion-guide-mobile.pdf',
      openInNewTab: true,
      buttonIcon: 'download-icon',
    },
  };

  ctaBottomDataDesk = {
    icon: 'clipboard',
    alt: 'A clipboard and a vial',
    title: 'Speak to your doctor about your screening options',
    button: {
      buttonLabel: 'Doctor Discussion Guide',
      buttonUrl:
        '/assets/pdf/type-1-diabetes-screening-doctor-discussion-guide.pdf',
      openInNewTab: true,
      buttonIcon: 'download-icon',
    },
  };

  ctaBottomDataDesk2 = {
    icon: 'doctors',
    alt: 'A care team',
    title: `Are you an HCP looking for<br class="d-none d-lg-inline" /> information for your patients? <br class="d-none d-lg-inline" />We've got resources for you!`,
    button: {
      buttonLabel: 'Discover HCP Resources',
      buttonUrl: appPaths.RESOURCE + '/',
      openInNewTab: false,
      buttonIcon: 'right-icon',
    },
  };

  ngOnInit(): void {
    const sectionIds = this.jumpToData.map((item) => item.buttonFragment);
    this.scrollSpyService.initObserver(sectionIds);

    this.activeSection$ = this.scrollSpyService.activeSection$;
  }

  ngOnDestroy(): void {
    this.scrollSpyService.disconnectObserver();
  }
}
